import { LoadPanel, TreeList, CheckBox, Button } from "devextreme-react";
import { Column } from "devextreme-react/tree-list";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import BreadCrumb from "../../../components/breadCrumb/BreadCrumb";
import CancelSaveHeader from "../../../components/customPageHeader/CancelSaveHeader";
import { ToastDisplayer } from "../../../components/toastDisplay/ToastDisplayer";
import {
  getAllCatSubcategoriesApi,
  saveUserProjectMappingApi,
} from "../../../api/companyUserApi";
import "./AssignUserProjects.scss";
import AddNewSubHeader from "../../../components/customPageHeader/SaveNewHeader";

export default function AssignUserProjects() {
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { userdata } = location.state || {};

  const [allData, setAllData] = useState([]);

  /* ================= FETCH ================= */

  useEffect(() => {
    if (userdata?.companytransid && userdata?.transid) {
      fetchSubcategories();
    }
  }, [userdata]);

  const fetchSubcategories = async () => {
    try {
      setLoading(true);

      const result = await getAllCatSubcategoriesApi(
        userdata?.companytransid,
        userdata?.transid,
      );

      const apiData = result.data.data;

      const filteredData = apiData.filter(
        (category) => category.subcategories?.length > 0
      );

      let formattedData = [];

      filteredData.forEach((category) => {
        const catId = `cat-${category.category_id}`;

        formattedData.push({
          ID: catId,
          parentId: 0,
          name: category.category_name,
          type: "category",
          actualId: category.category_id,
          isSelected: false,
        });

        category.subcategories.forEach((sub) => {
          formattedData.push({
            ID: sub.transid,
            parentId: catId,
            name: sub.ticketsubcatname,
            description: sub.description,
            type: "subcategory",
            actualId: sub.transid,
            isSelected: sub.selected || false,
          });
        });
      });

      // 🔥 Auto mark parent if any child selected
      formattedData = formattedData.map((item) => {
        if (item.type === "category") {
          const children = formattedData.filter((x) => x.parentId === item.ID);
          const anySelected = children.some((c) => c.isSelected);
          return { ...item, isSelected: anySelected };
        }
        return item;
      });

      setAllData(formattedData);
    } catch (error) {
      ToastDisplayer("error", "Unable to fetch projects!");
    } finally {
      setLoading(false);
    }
  };

  /* ================= SELECTION LOGIC ================= */

  const updateSelection = (items, targetId, newValue) => {
    return items
      .map((item) => {
        // CLICKED ITEM
        if (item.ID === targetId) {
          return { ...item, isSelected: newValue };
        }

        // UPDATE PARENT BASED ON CHILD
        if (item.type === "category") {
          const children = items.filter((x) => x.parentId === item.ID);

          const anyChildSelected = children.some((child) =>
            child.ID === targetId ? newValue : child.isSelected,
          );

          return { ...item, isSelected: anyChildSelected };
        }

        return item;
      })
      .map((item) => {
        // IF PARENT CLICKED → UPDATE ALL CHILDREN
        const clickedItem = items.find((x) => x.ID === targetId);

        if (clickedItem?.type === "category" && item.parentId === targetId) {
          return { ...item, isSelected: newValue };
        }

        return item;
      });
  };

  const handleCheckboxChange = (id, value) => {
    const updated = updateSelection(allData, id, value);
    setAllData(updated);
  };

  /* ================= SAVE ================= */

  const handleSave = async () => {
    try {
      setLoading(true);

      const selectedSubCategories = allData
        .filter((x) => x.type === "subcategory" && x.isSelected)
        .map((x) => x.actualId);

      const payload = {
        user_id: userdata?.transid,
        subcategory_ids: selectedSubCategories,
      };

      const result = await saveUserProjectMappingApi(payload);

      if (result.status === 200 || result.status === 201) {
        ToastDisplayer("success", "Projects assigned successfully!");
        navigate("/Developer");
      } else {
        ToastDisplayer("error", "Failed to assign projects.");
      }
    } catch (error) {
      ToastDisplayer(
        "error",
        error?.response?.data?.message || "Error while saving.",
      );
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate(-1);
  };

  /* ================= UI ================= */

  return (
    <>
      {loading && <LoadPanel visible={true} />}

      <div className="projPage">
        <div className="headerComponent">
          <div className="headerContainer1">
            <div className="title">
              <span class="icon-size">
                <i class="ri-task-line"></i>
              </span>
              {/* <p>Assign Projects - {userdata?.cmpuserusername || ""}</p> */}
              <BreadCrumb />
            </div>
          </div>
          <div className="headerContainer2">
            <Button
              text="Cancel"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleCancel}
            />

            <Button
              className="saveBtn"
              text="Save Details"
              // icon="add"
              stylingMode="outlined"
              type="default"
              width={140}
              onClick={handleSave}
            />

            {/* <CustomPageHeader
                      // titleName={"Customers"}
                      handleCreateNew={handleCreateNew}
                      btnText={"Add Client"}
                    /> */}
          </div>
        </div>
        {/* <AddNewSubHeader
          titleName={`Assign Projects - ${userdata?.cmpuserusername || ""}`}
          handleSaveDetails={handleSave}
          handleCancel={handleCancel}
          cancelText={"Cancel"}
          saveText={"Save Details"}
          iconClass={"ri-task-line"}
        /> */}

        <div className="projMain">
          <div className="mainAddCustSection middlePart">
            {allData.length > 0 ? (

              <TreeList
                dataSource={allData}
                keyExpr="ID"
                parentIdExpr="parentId"
                showBorders={false}
                // columnAutoWidth={true}
                columnAutoWidth={window.innerWidth <= 480 ? true : false}
              >
                <Column
                  width="400"
                  minWidth={180}
                  dataField="name"
                  caption="Project List"
                // alignment="center"
                />

                <Column
                  dataField="description"
                  caption="Description"
                  alignment="center"
                  cellRender={(data) =>
                    data.data.parentId !== 0 ? (
                      <div
                        className="desc-cell"
                        style={{
                          color: "#6a6565",
                          fontWeight: 500,
                        }}
                      >
                        {data.value}
                      </div>
                    ) : (
                      "-"
                    )
                  }
                />
                <Column
                  caption="Select"
                  alignment="left"
                  cellRender={(cellData) => (
                    <CheckBox
                      value={cellData.data.isSelected}
                      onValueChanged={(e) =>
                        handleCheckboxChange(cellData.data.ID, e.value)
                      }
                    />
                  )}
                />
              </TreeList>
            ) : (
              <div style={{ padding: "20px" }}>
                No projects available for this user.
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
